import { render, staticRenderFns } from "./SenderListTooltip.vue?vue&type=template&id=6e0ec5e9&scoped=true"
import script from "./SenderListTooltip.vue?vue&type=script&lang=js"
export * from "./SenderListTooltip.vue?vue&type=script&lang=js"
import style0 from "./SenderListTooltip.vue?vue&type=style&index=0&id=6e0ec5e9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0ec5e9",
  null
  
)

export default component.exports